import { render } from "./editEntity.vue?vue&type=template&id=62f28391&scoped=true"
import script from "./editEntity.vue?vue&type=script&lang=js"
export * from "./editEntity.vue?vue&type=script&lang=js"

import "./editEntity.vue?vue&type=style&index=0&id=62f28391&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f28391"]])

export default __exports__